import React from 'react';

function Field({ label, value, onChange, type = 'text', placeholder }) {
  return (
    <label className="block">
      <span className="text-white/40 text-xs font-bold tracking-widest uppercase">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1 w-full bg-[#111115] border border-white/10 focus:border-primary text-white text-lg px-4 py-3.5 outline-none"
      />
    </label>
  );
}

export default function WalkInDetails({ data, onChange }) {
  return (
    <div>
      <h2 className="text-white font-black text-3xl uppercase mb-2">Your details</h2>
      <p className="text-white/40 text-sm mb-8">We need these to set up your session and contact you.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="First name" value={data.first_name} onChange={(v) => onChange('first_name', v)} />
        <Field label="Last name" value={data.last_name} onChange={(v) => onChange('last_name', v)} />
        <Field label="Email" type="email" value={data.email} onChange={(v) => onChange('email', v)} />
        <Field label="Phone" type="tel" value={data.phone} onChange={(v) => onChange('phone', v)} />
        <Field label="Date of birth" type="date" value={data.dob} onChange={(v) => onChange('dob', v)} />
        <Field label="Postcode" value={data.postcode} onChange={(v) => onChange('postcode', v)} />
      </div>
    </div>
  );
}